// @ts-nocheck
import { useState, useEffect } from "react"
import SEOHead from "../components/head"
import { Slice } from "gatsby"
import { get, find } from "lodash"
import Layout from "../components/layout"
import { useDispatch, addNode, removeNode, useSelector } from "@ggs/store"
import { Box } from "@mui/material"
// travel page components
import { Hero, ContactCTA, DynamicSubNav, TextOverview, Map, SuggestedTrips } from "../components"
import {
  useStaffData,
  useDynamicSubNav,
  useGeoData,
  useTripsData,
  useGeoPagesSolrData,
} from "../local/hooks"
import { mapWishlistData, mapArticleTeaser } from "../helpers/data-mappers"

export default function PlacesToGoSubPageView(props) {
  const placesToGoSubPage = get(props, "data", {})
  const { hero, breadcrumbs, text_overview, contact_cta } = placesToGoSubPage
  const dispatch = useDispatch()
  const wishlist = useSelector((state) => state.views.wishlist)
  const likedTrips = wishlist?.trip && wishlist?.trip.map((trip) => trip.nid)
  const { getStaffByDestination } = useStaffData()
  const { getGeoData } = useGeoData()
  const [contactCtaStaff, setContactCtaStaff] = useState(null)
  const [geoData, setGeoData] = useState(null)
  const [suggestedTrips, setSuggestedTrips] = useState(null)
  const [tripItineraryUrl, setTripItineraryUrl] = useState(null)
  const [travelInformationPages, setTravelInformationPages] = useState(null)
  const [tripIdeaPages, setTripIdeaPages] = useState(null)
  const { getTripsByCountryAndDestination } = useTripsData()
  const { getTravelInformationPages, getTripIdeaPages } = useGeoPagesSolrData()
  const userCountry = useSelector((state) => state.settings.country)
  const parent = get(placesToGoSubPage, "parent_page", null)
  const destinationTitle = get(parent, "destinations[0].title", null)
  const refDestinationId = get(parent, "destinations.[0].external_id", "")
  const refCountryId = parent?.external_id || ""
  const refCountryName = parent?.title || ""

  // Resolve Solr data.
  useEffect(() => {
    const destinationNid = get(parent, "destinations[0].external_id", null)
    if (destinationNid) {
      getStaffByDestination(destinationNid).then((data) => {
        setContactCtaStaff(data)
      })
    }
    if (parent?.external_id) {
      getGeoData(parent.external_id).then((data) => {
        setGeoData(data)
      })
      // get trip idea links
      getTripIdeaPages(parent.external_id).then((data) => {
        setTripIdeaPages(data)
      })
      // get travel information links
      getTravelInformationPages(parent.external_id).then((data) => {
        setTravelInformationPages(data)
      })
    }
  }, [])

  const subNav = useDynamicSubNav({
    title: parent?.title || "Overview",
    uri: parent?.link?.uri || "#",
    nid: parent?.external_id,
  })

  useEffect(() => {
    const tripUrl = find(subNav, (navLink) => navLink.title === "Trip Itineraries")?.uri
    setTripItineraryUrl(tripUrl)
  }, [subNav])

  useEffect(() => {
    getTripsByCountryAndDestination(
      refDestinationId,
      refCountryId,
      placesToGoSubPage?.suggested_trips
    ).then((data) => {
      const filteredData = mapWishlistData(likedTrips, data)
      setSuggestedTrips({
        title: placesToGoSubPage?.suggested_trips?.title || "",
        subtitle: placesToGoSubPage?.suggested_trips?.subtitle || "",
        link: { title: "All Trips", uri: tripItineraryUrl || "/trips" },
        items: filteredData,
      })
    })
  }, [userCountry, tripItineraryUrl])

  const addToWishList = (selectedEntity) => {
    const filteredState = mapArticleTeaser(suggestedTrips.items, selectedEntity, true)
    setSuggestedTrips({
      ...suggestedTrips,
      items: filteredState,
    })
    dispatch(
      addNode({ type: selectedEntity.contentType, entity: selectedEntity, idPropertyKey: "nid" })
    )
  }

  const removeFromWishList = (selectedEntity) => {
    const filteredState = mapArticleTeaser(suggestedTrips.items, selectedEntity, false)
    setSuggestedTrips({
      ...suggestedTrips,
      items: filteredState,
    })
    dispatch(removeNode({ type: selectedEntity.contentType, findPredicate: selectedEntity }))
  }

  if (!placesToGoSubPage) {
    return <Box>{t("Places to go not found")}</Box>
  }

  const getBreadcrumbs = () => {
    const breadcrumbs = [
      {
        title: "Home",
        uri: "/",
      },
      {
        title: "Destinations",
        uri: "/destinations",
      },
    ]

    if (placesToGoSubPage?.parent_page?.destinations?.[0]) {
      breadcrumbs.push({
        title: placesToGoSubPage?.parent_page?.destinations?.[0]?.title,
        uri: placesToGoSubPage?.parent_page?.destinations?.[0]?.slug,
      })
    }

    if (placesToGoSubPage?.parent_page) {
      breadcrumbs.push({
        title: placesToGoSubPage?.parent_page?.title,
        uri: placesToGoSubPage?.parent_page?.link?.uri,
      })
    }

    breadcrumbs.push({
      title: "Places to Go",
    })

    return breadcrumbs
  }

  return (
    <>
      {ComposeHead(props)}
      <Layout
        hero={
          <Hero
            title={hero?.title}
            subtitle={hero?.subtitle}
            media={hero?.images}
            location={hero?.location}
            subtitleImageUrl={hero?.subtitleImageUrl}
            video={hero?.video}
            path={getBreadcrumbs()}
          />
        }
      >
        {subNav && (
          <DynamicSubNav
            links={subNav}
            travelInformation={travelInformationPages}
            tripIdea={tripIdeaPages}
            countryId={refCountryId}
            activeLink={"Places To Go"}
          />
        )}
        {text_overview && (
          <TextOverview
            title={text_overview?.title}
            subtitle={text_overview?.subtitle}
            description={text_overview?.description}
            link={text_overview?.link}
            layout={text_overview?.layout}
          />
        )}
        {geoData && (
          <Map items={geoData} country={refCountryName} showFilters initialFilter="City" />
        )}
        {suggestedTrips?.items?.length && (
          <SuggestedTrips
            {...suggestedTrips}
            onLike={addToWishList}
            onUnlike={removeFromWishList}
          />
        )}
        <ContactCTA
          title={contact_cta?.title}
          subtitle={contact_cta?.subtitle}
          description={contact_cta?.description}
          link={contact_cta?.link}
          image={contact_cta?.image}
          staff={contactCtaStaff}
        />
        <Slice alias="preFooterStyle1" destinationId={destinationTitle} />
      </Layout>
    </>
  )
}

export const ComposeHead = (props) => {
  const metatag = get(props.data, "metatag.items")
  const url = get(props.data, "slug")
  const image = get(props.data, "hero.images[0].variants[0].url")
  return <SEOHead metas={metatag} image={image} url={url} />
}
